module.exports = __webpack_public_path__ + "img/album18_11.2fc776bb.jpg";